(function(){
  const ZOOM=5.5;

  function initGallery(gallery){
    const stage=gallery.querySelector('[data-product-stage]');
    const main=gallery.querySelector('.srn-product-main-image');
    const lens=gallery.querySelector('[data-zoom-lens]');
    const placeholder=gallery.querySelector('[data-demo-back-panel]');
    const thumbs=[...gallery.querySelectorAll('.srn-product-thumb')];
    if(!stage) return;

    function activate(btn){
      thumbs.forEach(x=>x.classList.toggle('active',x===btn));
      stage.classList.remove('zooming');

      if(btn.dataset.galleryPlaceholder){
        if(main) main.style.display='none';
        if(placeholder) placeholder.hidden=false;
        return;
      }

      if(placeholder) placeholder.hidden=true;
      if(!main) return;
      main.style.display='block';
      main.src=btn.dataset.gallerySrc||main.src;
      main.dataset.zoomSrc=btn.dataset.galleryZoom||btn.dataset.gallerySrc||main.src;
      if(btn.dataset.galleryAlt) main.alt=btn.dataset.galleryAlt;
      if(lens){
        lens.style.backgroundImage='url("'+(main.dataset.zoomSrc||main.src).replace(/"/g,'%22')+'")';
      }
    }

    thumbs.forEach(btn=>btn.addEventListener('click',()=>activate(btn)));

    if(main && lens){
      let zoomUrl='';
      let zoomNaturalW=0;
      let zoomNaturalH=0;

      function loadZoomSource(url){
        zoomUrl=url;
        zoomNaturalW=0;
        zoomNaturalH=0;
        const pre=new Image();
        pre.onload=()=>{
          zoomNaturalW=pre.naturalWidth||0;
          zoomNaturalH=pre.naturalHeight||0;
        };
        pre.src=url;
        lens.style.backgroundImage='url("'+url.replace(/"/g,'%22')+'")';
      }

      function primeZoom(){
        loadZoomSource(main.dataset.zoomSrc||main.src);
      }

      function isPhotoVisible(){
        return main.style.display!=='none' && main.getBoundingClientRect().width>0;
      }

      main.addEventListener('mouseenter',()=>{
        if(!isPhotoVisible()) return;
        primeZoom();
        stage.classList.add('zooming');
      });

      main.addEventListener('mouseleave',()=>{
        stage.classList.remove('zooming');
      });

      main.addEventListener('mousemove',e=>{
        if(!isPhotoVisible()) return;
        stage.classList.add('zooming');

        const imgRect=main.getBoundingClientRect();
        const stageRect=stage.getBoundingClientRect();

        const rawX=e.clientX-imgRect.left;
        const rawY=e.clientY-imgRect.top;
        const sampleX=Math.max(0,Math.min(imgRect.width,rawX));
        const sampleY=Math.max(0,Math.min(imgRect.height,rawY));

        const lensW=lens.offsetWidth||86;
        const lensH=lens.offsetHeight||86;

        let left=e.clientX-stageRect.left-lensW/2;
        let top=e.clientY-stageRect.top-lensH/2;
        left=Math.max(8,Math.min(stageRect.width-lensW-8,left));
        top=Math.max(8,Math.min(stageRect.height-lensH-8,top));
        lens.style.left=left+'px';
        lens.style.top=top+'px';

        const current=main.dataset.zoomSrc||main.src;
        if(current!==zoomUrl){
          loadZoomSource(current);
        }

        const sourceZoomX=zoomNaturalW ? (zoomNaturalW/imgRect.width) : ZOOM;
        const sourceZoomY=zoomNaturalH ? (zoomNaturalH/imgRect.height) : ZOOM;
        const effectiveZoom=Math.max(1,Math.min(ZOOM,sourceZoomX,sourceZoomY));

        let bgW=imgRect.width*effectiveZoom;
        let bgH=imgRect.height*effectiveZoom;

        if(zoomNaturalW && zoomNaturalH){
          const sourceAspect=zoomNaturalW/zoomNaturalH;
          bgW=Math.min(bgW,zoomNaturalW);
          bgH=bgW/sourceAspect;

          if(bgH>zoomNaturalH){
            bgH=zoomNaturalH;
            bgW=bgH*sourceAspect;
          }
        }

        lens.style.backgroundSize=bgW+'px '+bgH+'px';

        const normalizedX=imgRect.width ? sampleX/imgRect.width : 0;
        const normalizedY=imgRect.height ? sampleY/imgRect.height : 0;
        const bgX=(lensW/2)-(normalizedX*bgW);
        const bgY=(lensH/2)-(normalizedY*bgH);
        lens.style.backgroundPosition=bgX+'px '+bgY+'px';
      });

      function openLightbox(){
        if(!isPhotoVisible()) return;
        const box=document.createElement('div');
        box.className='srn-image-lightbox';
        box.innerHTML='<button type="button" aria-label="Close image">×</button><img src="'+(main.dataset.zoomSrc||main.src)+'" alt=""><div class="srn-lightbox-zoom-lens" aria-hidden="true"></div>';
        document.body.appendChild(box);
        const lightImg=box.querySelector('img');
        const lightLens=box.querySelector('.srn-lightbox-zoom-lens');
        let lightNaturalW=0,lightNaturalH=0;
        const lightPre=new Image();
        lightPre.onload=()=>{lightNaturalW=lightPre.naturalWidth||0;lightNaturalH=lightPre.naturalHeight||0};
        lightPre.src=lightImg.src;
        lightLens.style.backgroundImage='url("'+lightImg.src.replace(/"/g,'%22')+'")';
        box.addEventListener('mousemove',e=>{
          if(e.target.closest('button')){box.classList.remove('zooming');return}
          const r=lightImg.getBoundingClientRect();
          if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom){box.classList.remove('zooming');return}
          box.classList.add('zooming');
          const lw=lightLens.offsetWidth||104, lh=lightLens.offsetHeight||104;
          lightLens.style.left=Math.max(8,Math.min(window.innerWidth-lw-8,e.clientX-lw/2))+'px';
          lightLens.style.top=Math.max(8,Math.min(window.innerHeight-lh-8,e.clientY-lh/2))+'px';
          const sx=Math.max(0,Math.min(r.width,e.clientX-r.left)), sy=Math.max(0,Math.min(r.height,e.clientY-r.top));
          const sourceZoomX=lightNaturalW?(lightNaturalW/r.width):ZOOM;
          const sourceZoomY=lightNaturalH?(lightNaturalH/r.height):ZOOM;
          const ez=Math.max(1,Math.min(ZOOM,sourceZoomX,sourceZoomY));
          let bw=r.width*ez,bh=r.height*ez;
          if(lightNaturalW&&lightNaturalH){const a=lightNaturalW/lightNaturalH;bw=Math.min(bw,lightNaturalW);bh=bw/a;if(bh>lightNaturalH){bh=lightNaturalH;bw=bh*a}}
          lightLens.style.backgroundSize=bw+'px '+bh+'px';
          lightLens.style.backgroundPosition=((lw/2)-(r.width?sx/r.width:0)*bw)+'px '+((lh/2)-(r.height?sy/r.height:0)*bh)+'px';
        });
        box.addEventListener('mouseleave',()=>box.classList.remove('zooming'));
        document.body.style.overflow='hidden';
        const close=()=>{
          box.remove();
          document.body.style.overflow='';
          document.removeEventListener('keydown',esc);
        };
        const esc=e=>{if(e.key==='Escape')close()};
        box.addEventListener('click',e=>{if(e.target===box)close()});
        box.querySelector('button').addEventListener('click',close);
        document.addEventListener('keydown',esc);
      }

      main.addEventListener('click',e=>{
        e.stopPropagation();
        openLightbox();
      });
    }
  }

  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  });
})();
